module.exports = __webpack_public_path__ + "img/center-on-03.5390680c.jpg";